<script setup lang="ts">
import { computed } from 'vue';


const props = withDefaults(
    defineProps<{
        href: string | null 
        target?: string
        mailto?: boolean
        tel?: boolean
    }>(),
    {
        href: '',
        target: '',
        mailto: false,
        tel: false,
    },
);

const link = computed(() => {
    if (props.mailto) {
        return `mailto:${props.href}`;
    } else if (props.tel) {
        return `tel:${props.href}`;
    } else {
        return props.href;
    }
});

</script>

<template>
    <a :href="link || undefined" :target="target">
        <slot>{{ href }}</slot>
    </a>
</template>